
(function ($) {
  "use strict";
  const { Swiper } = require("swiper/bundle");

  /* TSAP LEADERBOARD SEE MORE */
  if($(".top-resume-services") ){
    //Top Resume Services see more
    $(document).on(
      "click",
      ".top-resume-services .top-resume-services__more a",
      function (e) {
        e.preventDefault();

        $(this)
          .parents(".top-resume-services")
          .find(".resumes-item-hide")
          .each(function (key, value) {
            $(this).removeAttr("style");
            $(this).addClass("resumes-item");
            $(this).slideDown({
              start: function () {
              },
              easing: "linear",
              duration: 300,
              complete: function () {
                $(this).removeClass("resumes-item-hide");
                if (
                  $(this)
                    .parents(".top-resume-services")
                    .find(".resumes-item-hide").length == 0
                ) {
                  $(this).parents(".top-resume-services__more").hide();
                  $(this)
                    .parents(".top-resume-services")
                    .find(".top-resume-services__more")
                    .hide();
                  $(this)
                    .parents(".top-resume-services")
                    .find(".top-resume-services__less")
                    .show();
                }
              },
            });
          });
      }
    );

    //Top Resume Services see less
    $(document).on(
      "click",
      ".top-resume-services .top-resume-services__less a",
      function (e) {
        e.preventDefault();

        $(this)
          .parents(".top-resume-services")
          .find(".resumes-item")
          .each(function (key, value) {
            if (key > 4) {
              $(this).slideUp({
                easing: "linear",
                duration: 300,
                complete: function () {
                  $(this)
                    .removeClass("resumes-item")
                    .addClass("resumes-item-hide");
                },
              });
            }
          });

        $(this).parents(".top-resume-services__less").hide();
        $(this)
          .parents(".top-resume-services")
          .find(".top-resume-services__more")
          .show();
      }
    );
  }
  /* END TSAP LEADERBOARD SEE MORE */

  /* Table of Contents TOC */
  if ($(".toc").length > 0) {
    const TOC = {
      init: function () {
        this.createElements();
        this.bindEvents();
        this.markSections();
      },
      createElements: function () {
        const $tocSource = $(".blog-wrap");
        const $tocRoot = $(".toc");
        const $tocEl = $("<div>", {
          class: "toc-container",
        });

        $tocRoot.prepend($tocEl);

        const $headingList = $tocSource
          .find(".post-content > h2,  h2.service-cost-toc")
          .filter((i, e) => !!$(e).text().trim().length)
          .map((i, el) => {
            const $el = $(el);
            const id = `tocHeading${i}`;
            const $link = $("<a>").text($el.text());
            const $li = $("<li>", {
              "data-heading": id,
            }).append($link);

            $link.prepend(
              $("<span>", {
                class: "fmp-marker",
              })
            );

            if ($el.attr("class")?.includes("toc")) {
              $el.attr("id", id);
              $el.css({
                marginBottom: 0,
                minHeight: 0,
                padding: 0,
                height: 0,
                width: 0,
                overflow: "hidden",
                display: "block",
                marginTop: 0,
                border: 0,
              });
            } else {
              $el.wrapInner(
                $("<span>")
              );

              $el.wrapInner(
                $("<div>", {
                  id: id,
                  class: "fmp-h2-wrap",
                })
              );
            }

            $link.on("click", () => {
              var offsetHeading = 0;
              if ($("#".concat(id)).attr("class") === "fmp-h2-wrap") {
                offsetHeading = 60;
              }

              $([document.documentElement, document.body]).animate(
                {
                  scrollTop: $(`#${id}`).offset().top - offsetHeading,
                },
                200,
                "linear"
              );
            });

            return $li.get(0);
          });

        $tocEl.append(
          $("<div>", {
            class: "toc-label-wrap",
          })
        );

        $(".toc-label-wrap").append(
          $("<label>", {
            class: "toc-label",
            text: "Table of Contents",
          })
        );

        $(".toc-label-wrap").append(
          $("<div>", {
            class: "toc-info",
            text: "Click to see the article outline and go directly to any section.",
          })
        );

        $tocEl.append(
          $("<ul>", {
            class: "toc-list",
          }).append($headingList)
        );

        $tocEl.append(
          $("<div>", {
            class: "toc-list-close",
          })
        );
      },
      bindEvents: function () {
        $(window).on("scroll", this.markSections.bind(this));
      },
      markSections: function () {
        const $articleEl = $(".blog-wrap");
        const currentHeadingId = $articleEl
          .find(
            ".post-content > h2, .post-content > h2 div, .post-content > .service-cost, h2.service-cost-toc"
          )
          .filter(
            (i, el) => $(window).scrollTop() >= $(el).offset().top - 120
          )

          .map((i, el) =>
            $(el).attr("id")
              ? $(el).attr("id")
              : $(el).find("> .service-cost-toc").attr("id")
          )
          .get(-1);

        $("[data-heading]").removeClass("toc-current");
        $(`[data-heading='${currentHeadingId}']`).addClass("toc-current");
        $(`[data-heading='${currentHeadingId}']`).addClass("checked");
      },
    };

    TOC.init();

    $(".toc-label-wrap").on("click", function () {
      $(".toc").addClass("expanded");
    });

    $(".toc-list-close").on("click", function () {
      $(".toc").removeClass("expanded");
    });

    $(window).on("load resize", function () {
      $(".toc").css("height", $(".toc-label-wrap").outerHeight() + 24);
    });
  }
  /* END Table of Contents TOC */
  
  /* CHANGE TEXT IN BLOG BASED ON */
  if($(".resume-writer__reviews__text")){
    $(window).on("load resize", function () {
      let windowWidth = $(window).width();
      if (windowWidth < 640) {
        resumeWriterReviews();
      } else {
        resumeWriterReviewsRestore();
      }
    });
  }
  /* END CHANGE TEXT IN BLOG BASED ON */

  // resume writer text replacement in mobile
  function resumeWriterReviews() {
    $(".resume-writer__reviews__text p").html(function () {
      return $(this).html().replaceAll("based on", "-");
    });
  }

  // resume writer text restore in desktop
  function resumeWriterReviewsRestore() {
    $(".resume-writer__reviews__text p").html(function () {
      return $(this).html().replaceAll("-", "based on");
    });
  }

  /* BACK TO TOP SCROLL */
  if("#back-to-top"){
    $("#back-to-top").click(function () {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  }
  /* END BACK TO TOP SCROLL */
  
  // TSAP Review IDs 
  if( $(".tsap-reviews") ) {
    $(".tsap-reviews").each(function(index) {
      index = index + 1;
      $( this ).attr( "id","service_" + index );
    });
  }


})(jQuery);
